import React from "react";

/**
 * Canales Furniture brand mark — real gradient PNG shipped in /brand/canales-logo.png.
 * Falls back to a hand-drawn SVG replica if the image fails to load (offline mode).
 */
export const CanalesLogo = ({ width = 160, className = "", plate = true }) => {
  const h = width * (plate ? 0.48 : 0.42);
  return (
    <img
      src="/brand/canales-logo.png"
      alt="Canales Furniture"
      width={width}
      height={h}
      className={className}
      style={{ objectFit: "contain", display: "block" }}
      onError={(e) => {
        // Fallback to SVG replica if the image can't load (offline / cached issue)
        e.currentTarget.replaceWith(
          Object.assign(document.createElement("span"), {
            innerHTML: `<svg viewBox="0 0 240 116" width="${width}" height="${h}" role="img" aria-label="Canales Furniture">
              <rect x="2" y="2" width="236" height="112" rx="12" fill="#0d1a3f" stroke="#000" stroke-width="2" />
              <text x="120" y="66" font-family="Fredoka, Impact, sans-serif" font-weight="900" font-size="26" letter-spacing="2" fill="#FFD100" text-anchor="middle">CANALES</text>
              <text x="120" y="94" font-family="Fredoka, Impact, sans-serif" font-weight="900" font-size="26" letter-spacing="2" fill="#FFD100" text-anchor="middle">FURNITURE</text>
              <rect x="30" y="100" width="180" height="4" rx="1" fill="#E3000F" />
            </svg>`,
          })
        );
      }}
    />
  );
};

export default CanalesLogo;
